export const templateCategories = Object.freeze([
  {
    value: "MARKETING",
    label: "Marketing",
  },
  {
    value: "UTILITY",
    label: "Utility",
  },
  {
    value: "AUTHENTICATION",
    label: "Authentication",
  },
]);

export const customTemplateCategory = Object.freeze([
  {
    value: "Report",
    label: "Report",
  },
  {
    value: "Transaction",
    label: "Transaction",
  },
  {
    value: "Others",
    label: "Others",
  },
]);

export const haptikSMSChannelCategories = Object.freeze([
  {
    value: "TRANSACTIONAL",
    label: "Transactional",
  },
  {
    value: "PROMOTIONAL",
    label: "Promotional",
  },
  {
    value: "SERVICE",
    label: "Service",
  },
]);

export const CALL_TO_ACTION = "Call To Action";
export const QUICK_REPLIES = "Quick Replies";

export const buttonsOptions = [
  {
    label: QUICK_REPLIES,
    value: QUICK_REPLIES,
  },
  {
    label: CALL_TO_ACTION,
    value: CALL_TO_ACTION,
  },
];

export const CALL_PHONE_NUMBER = "Call Phone Number";
export const VISIT_WEBSITE = "Visit Website";
export const callToActionButtonOptions = [
  {
    label: CALL_PHONE_NUMBER,
    value: CALL_PHONE_NUMBER,
  },
  {
    label: VISIT_WEBSITE,
    value: VISIT_WEBSITE,
  },
];

export const STATIC_URL = "Static";
export const DYNAMIC_URL = "Dynamic";
export const urlTypeOptions = [
  {
    label: STATIC_URL,
    value: STATIC_URL,
  },
  {
    label: DYNAMIC_URL,
    value: DYNAMIC_URL,
  },
];

export const TABLE_LIST_COLUMN_COLUMN = [
  {
    id: 1,
    heading: "Template Name",
  },
  {
    id: 2,
    heading: "Status",
  },
  {
    id: 3,
    heading: "Category",
  },
  {
    id: 4,
    heading: "Language(s)",
  },
  {
    id: 5,
    heading: "Created By",
  },
];

// template status
export const APPROVED = "APPROVED";
export const WAITING = "WAITING";
export const PENDING = "PENDING";
export const REJECTED = "REJECTED";
export const DISABLED = "DISABLED";
export const IN_APPEAL = "IN_APPEAL";
export const PENDING_DELETION = "PENDING_DELETION";

export const colorDictionary = {
  [APPROVED]: "#0DB350",
  [REJECTED]: "#DC6803",
  [WAITING]: "#F6A400",
  [PENDING]: "#FEC84B",
  [DISABLED]: "#999999",
  [IN_APPEAL]: "#454ADE",
  [PENDING_DELETION]: "#132E2F",
};

export const backgroundDictionary = {
  APPROVED: "#CEFBE0",
  REJECTED: "#F0F0F0",
  WAITING: "#FFF0D3",
  PENDING: "#FFF0D3",
  DISABLED: "#F0F0F0",
  IN_APPEAL: "#B0C4DE",
  PENDING_DELETION: "#FDEED1",
};

export const ACTION_OPTIONS = [
  {
    label: "Duplicate",
    value: "duplicate",
    leftIconProps: {
      iconName: "duplicate",
      iconSize: "tiny",
      color: "#464D6D",
    },
  },
  {
    label: "Edit",
    value: "edit",
    leftIconProps: {
      iconName: "editV3",
      iconSize: "tiny",
      color: "#464D6D",
    },
  },
  {
    label: "Delete",
    value: "delete",
    leftIconProps: {
      iconName: "delete",
      iconSize: "tiny",
      color: "#464D6D",
    },
  },
];

export const LIBRARY = "library";
export const ACTIVE = "active";
export const DELETED = "deleted";
